import React from "react";
import logo from "asset/img/onboard/client.png";
import client1 from "asset/img/onboard/1.png";
import client2 from "asset/img/onboard/2.png";
import client3 from "asset/img/onboard/3.png";
import client4 from "asset/img/onboard/4.png";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ONBOARD = [
  {
    feature: logo,
    title: "Hướng dẫn người mới",
    content:
      "Chào mừng bạn! Đây là hướng dẫn dành cho người mới. Nếu các bạn đã quen thuộc với hệ thống, hãy nhấn 'Bỏ qua' để tiếp tục sử dụng dịch vụ.",
  },
  {
    feature: client1,
    title: "Tải lên file mới",
    content:
      "Nhấp vào nút 'Thêm file' và tải lên file của bạn để bắt đầu. Hệ thống sẽ tự động phân tích thời lượng và đưa ra báo giá ước tính",
  },
  {
    feature: client2,
    title: "AI Kiểm duyệt & Báo giá",
    content:
      "Sau khi tải lên, AI sẽ tiến hành phân tích chuyên sâu trong khoảng 10 phút để gửi đến bạn báo giá chính xác nhất trong phần thanh toán.",
  },
  {
    feature: client3,
    title: "Thanh toán & Khởi tạo",
    content:
      "Sau khi thanh toán thành công. Hệ thống trí tuệ nhân tạo AI sẽ tự động kích hoạt tiến trình xử lý, phân tán và được kiểm duyệt kỹ càng trước khi trả file về cho bạn.",
  },
  {
    feature: client4,
    title: "Hoàn tất & Nhận kết quả",
    content:
      "Thời gian dự kiến trả file sẽ được hiển thị trên màn hình. Hệ thống sẽ tự động gửi email thông báo kèm đường dẫn tải file ngay khi quá trình kết thúc.",
  },
];

const OnboardContent = ({ index }) => {
  // -------------------------- VAR -----------------------------
  const selected = ONBOARD[index] || null;
  const title = selected?.title || "";
  const content = selected?.content || "";
  const feature = selected?.feature || null;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN ----------------------------
  return (
    <div
      key={index}
      className="animate-fade-in flex flex-col items-center justify-center gap-3"
    >
      <h2 className="mb-4 text-center text-2xl font-bold underline">{title}</h2>
      <p className="text-center text-[14px] text-base text-gray-600">
        {content}
      </p>
      <img src={feature} className="h-[200px] w-auto" alt="feature" />
    </div>
  );
};
export default OnboardContent;
